export const titleCase = (string: string):string => {
    return string
        .split(' ')
        .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}


export function numberWithCommas(x:number):string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convertBreakpointToNum(breakpoint: string):number{
    return +breakpoint.substring(0,breakpoint.length-2)
}

export function isMobile():boolean {
    return window.innerWidth < 1000
}